import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { IconBaseProps } from "react-icons/lib";

import { GiSpottedBug, GiHouse, GiVial, GiTreeBranch } from 'react-icons/gi'
import { BsPatchQuestion } from 'react-icons/bs';
import { MdOutlineCoronavirus } from 'react-icons/md';
import { HiOutlineClipboardList, HiOutlineLibrary } from 'react-icons/hi';
import { TbError404, TbBuildingCommunity } from 'react-icons/tb';
import { IoBusinessSharp, IoArrowBackCircle, IoCheckmarkCircle, IoPersonSharp } from 'react-icons/io5';

export type iconType = "BUG" | "COVID" | "BUSINESS" | "PERSON" | "HOUSE" | "VIAL" | "CLIPBOARD" | "BRANCH" | "BACKARROW" | "CHECKMARK" | "QUESTION" | "ERROR" | "REALESTATE" | "MUNICIPALITY"

interface Props extends WithTranslation, React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    type: iconType,
    iconProps?: IconBaseProps
};

class Icon extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    renderIcon(type: iconType, props?: IconBaseProps) {
        switch (type) {
            case "BUG":
                return <GiSpottedBug {...props} />;
            case "COVID":
                return <MdOutlineCoronavirus {...props} />;
            case "BUSINESS":
                return <IoBusinessSharp {...props} />;
            case "PERSON":
                return <IoPersonSharp {...props} />;
            case "HOUSE":
                return <GiHouse {...props} />;
            case "VIAL":
                return <GiVial {...props} />;
            case "CLIPBOARD":
                return <HiOutlineClipboardList {...props} />;
            case "BRANCH":
                return <GiTreeBranch {...props} />;
            case "BACKARROW":
                return <IoArrowBackCircle {...props} />;
            case "CHECKMARK":
                return <IoCheckmarkCircle {...props} />;
            case "QUESTION":
                return <BsPatchQuestion {...props} />;
            case "ERROR":
                return <TbError404 {...props} />;
            case "REALESTATE":
                return <TbBuildingCommunity {...props} />;
            case "MUNICIPALITY":
                return <HiOutlineLibrary {...props} />;
            default:
                return null;
        }
    }

    render() {
        const { type, iconProps } = this.props;
        return <div className="render-icon" {...this.props} >
            {this.renderIcon(type, iconProps)}
        </div>;
    }
};

export default withTranslation()(Icon);